import React, { useState, useEffect } from "react";

// styles
import "./index.scss";

export const WebsCta: React.FC<WebsCtaProps> = ({ callToAction }) => {
  const [showElement, setShowElement] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;

      const documentHeight =
        Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.clientHeight,
          document.documentElement.scrollHeight,
          document.documentElement.offsetHeight
        ) - windowHeight;

      const isAtTop = scrollTop == 0;
      const isAtBottom = scrollTop >= documentHeight - 150;
      setShowElement(isAtTop || isAtBottom);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <section className={`webs-cta-container ${showElement ? "show" : ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-2 webs-cta-container__logo">
              <img
                src={callToAction.enterpriseLogo.node.publicUrl}
                title={callToAction.enterpriseLogo.node.title}
                alt={callToAction.enterpriseLogo.node.altText}
              />
            </div>

            <div className="col-lg-10">
              {/* //todo: title must be added to this redirection */}
              <ul className="webs-cta-container__elements">
                {callToAction.webs.map((web, index) => (
                  <li className="element" key={index}>
                    <img
                      className="element__image"
                      src={web.webImage.node.publicUrl}
                      alt={web.webImage.node.altText}
                      title={web.webImage.node.title}
                    />
                    <a
                      className="element__redirection redirection-button"
                      target="__blank"
                      href={web.webUrl}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className={`bookins-cta-container ${showElement ? "show" : ""}`}>
        <div className="button-container flex justify-center">
          <a
            href={callToAction.booking.innerRedirection}
            className="cta__button redirection-button"
            rel="noopener noreferrer"
            target="_blank"
          >
            <button type="button" className="button style-primary-inverse">
              {callToAction.booking.innerText}
            </button>
          </a>
        </div>
      </section>
    </>
  );
};
